import '../privacy-policy/index.scss';

import React, { Component } from 'react';
import { withRouter } from 'react-router';

import AccountSubSecTitle from '../../components/accout-subsec-title';
import Footer from '../../containers/footer';
import MobileFooter from '../../containers/mob-footer';
import withMobileHeaderFooterAdding from '../../components/mobile-layout';

class PromotionalPrivacyPolicy extends Component {
  goBackOnClick = () => {
    const { history } = this.props;
    history.go(-1);
  };

  renderFathersDayHeadingAndText = ({ heading, points }) => {
    return (
      <div key={heading} style={{ paddingLeft: '2rem' }}>
        <p className="terms-pg__title u_text_transform_uppercase">{heading}</p>
        <ul style={{ paddingLeft: '2.8rem' }}>
          {points.map(point => (
            <p key={point} className="terms-pg__info">
              <li>{point}</li>
            </p>
          ))}
        </ul>
      </div>
    );
  };

  render() {
    const { goBackOnClick } = this;
    const {
      theme,
      mobileFooterClickHandler,
      activeKey,
      isMobileScreen,
      isAccountScreen
    } = this.props;
    const { location } = window;
    const { pathname } = location;

    const bunBelievableBKBash = [
      {
        id: 1,
        content: `Entries will only be considered valid if the participants follow all the steps mentioned
        above accurately.`
      },
      {
        id: 2,
        content: `Participants must have their own public Instagram account for us to be able to track valid
        entries.`
      },
      {
        id: 3,
        content: `The contest entries will commence from 28th May 2026 and end on 29th May 2026 at
        11:59 PM IST. Any entries received after this period shall not be eligible for the
        #BunBelievableBKBash contest.`
      },
      {
        id: 4,
        content: `The offer is valid only for the first 1000 valid participants, subject to successful completion
        of the contest requirements and voucher availability.`
      },
      {
        id: 5,
        content: `Participation in the contest does not guarantee receipt of a voucher, which shall be subject
        to eligibility verification and availability.`
      },
      {
        id: 6,
        content:
          'Each valid entry/participation will win one (1) Korean Kimchi Veg Whopper voucher only.'
      },
      {
        id: 7,
        content:
          'Only one (1) participation shall be accepted from one (1) Instagram handle.'
      },
      {
        id: 8,
        content: `Voucher codes shall be redeemable only through the Dine-in section on the Burger King
        App.`
      },
      {
        id: 9,
        content:
          'Voucher codes shall not be valid at Airport and Franchisee Burger King restaurants.'
      },
      {
        id: 10,
        content: `Voucher codes are valid for a limited period only, i.e. from 28th May 2026 to 28th August
        2026.`
      },
      {
        id: 11,
        content: `Burger King India reserves the right to discontinue issuance of vouchers once the limit of
        1000 valid winners is reached.`
      },
      {
        id: 12,
        content: `Burger King India reserves the right to cancel, reduce, amend, extend, modify or withdraw
        the offer and/or contest at its sole discretion at any time without prior notice to the
        participants. No claims/questions shall be entertained in this regard.`
      },
      {
        id: 13,
        content: `Impersonated Instagram handles and/or fake accounts (if identified or reported) shall be
        disqualified.`
      },
      {
        id: 14,
        content: `Restaurant timings may vary across locations. Restaurant operations shall remain subject to
        applicable State and Local Government guidelines and permitted operating hours/services.`
      },
      {
        id: 15,
        content: `The voucher shall be sent to the winners via Instagram DM. Burger King India team shall
        contact the winners and share the voucher code through Instagram Direct Message only.`
      },
      {
        id: 16,
        content: `By entering this contest pursuant to these T&C, each participant agrees to be bound by
        these T&C and by the sole decision(s) of Burger King India, whose decision shall be final
        and binding in relation to all matters connected with the contest. Burger King India shall not
        entertain any further correspondence in this regard.`
      },
      {
        id: 17,
        content:
          'In case of any dispute, courts at Mumbai shall have exclusive jurisdiction.'
      }
    ];

    const terms_conditions = [
      {
        id: 1,
        content:
          'Every order placed in dine-in/ take away/ delivery is subject to taxes and charges as applicable.'
      },
      {
        id: 2,
        content:
          'Please collect your invoice while placing the order at the restaurant. You can opt to receive electronic copy (e-copy) of your invoice by providing your mobile number while placing the Order or ask for physical copy. The invoice has complete details of the taxes and charges levied.'
      },
      {
        id: 3,
        content:
          'Burger King products has No Synthetic Colours and Artificial Flavours (excluding pepsi and other aerated drinks sold in the restaurant) and the products are for immediate consumption only.'
      },
      // {
      //   id: 4,
      //   content: 'PEPSI PRODUCTS DISCLAIMERS:',
      //   subItems: [
      //     'PEPSI, PEPSI BLACK AND MOUNTAIN DEW CONTAINS CAFFEINE.',
      //     'PLEASE NOTE THAT PEPSI BLACK CONTAIN NON-CALORIC SWEETNERS, THE CARBONATED WATER CONTAINS AN ADMIXTURE OF SUCRALOSE AND ACESULFAME POTASSIUM AND THE SAME IS NOT RECOMMENDED FOR CHILDREN; PREGNANT AND LACTATING MOTHERS.'
      //   ]
      // },
      {
        id: 4,
        content: 'COKE PRODUCTS DISCLAIMERS:',
        subItems: [
          'COCA-COLA, THUMS UP, COCA-COLA ZERO CONTAINS CAFFEINE.',
          'COCA-COLA ZERO CONTAIN NON-CALORIC SWEETENER. THIS CARBONATED WATER CONTAINS AN ADMIXTURE OF SUCRALOSE ANDACESULFAME POTASSIUM. NOT RECOMMENDED FOR CHILDREN; PREGNANT AND LACTATING MOTHERS.'
        ]
      },
      {
        id: 5,
        content:
          'In the New BK Chicken Burger the chicken content is approximate and indicative and is subject to variation in serve sizes, preparation process, sources of supply including seasonal changes/geographical/ weather conditions may have an impact.'
      },
      {
        id: 6,
        content:
          'For product nutrition and allergen information please refer to the menu available in the restaurant, Burger King App/ website.'
      },
      {
        id: 7,
        content:
          'For all product information please refer to the menu available in the restaurants or on the Burger King App/ website. All our products/ingredients are subject to availability.'
      },
      {
        id: 8,
        content:
          'Restaurant timings may vary for different locations. Restaurant operation is subject to State and Local Government guidelines/ orders with respect to permitted services/timings in different zones across cities.'
      },
      {
        id: 9,
        content:
          'Images used on the restaurant display/BK website & App/advertisement are for illustration purpose only and do not represent actual product.'
      },
      {
        id: 10,
        content:
          'For any contest run by Burger King India the entries will only be valid if all the contest T & C and steps are followed accurately.'
      },
      {
        id: 11,
        content:
          'All the contests are valid for the limited period only. Please check the contest T & C for more information. All our voucher contains a unique code.'
      },
      {
        id: 12,
        content:
          'It is mandatory to convey the offer before placing the order for its redemption.'
      },
      {
        id: 13,
        content:
          'By participating in the contest/asking for e-copy of invoice, participants agree to submit his/ her information to Burger King India, giving consent where necessary and appropriate for disclosures.'
      },
      {
        id: 14,
        content:
          'Burger King India has the right to modify/withdraw the offer/ promotional contest at its sole discretion at any time during the contest without any notification.'
      },
      {
        id: 15,
        content:
          'Each participant agrees to be bound by these T&C (including T & C for the contest) and by the sole decision(s) of Burger King India, whose decision shall be final in selecting the winning entries, in relation to all matters. Burger King India will entertain no further correspondence.'
      },
      {
        id: 16,
        content:
          'Burger King India’s maximum liability is not more than the amount of the voucher applicable for respective contest.'
      },
      {
        id: 17,
        content:
          'All the combo offers will be sold as per the Burger King India discretion. The combo offer cannot be sold separately. No two offers can be clubbed together for availing the any additional discount/ benefits.'
      },
      {
        id: 18,
        content:
          'For any further information, you can contact by writing to us at customercare@burgerking.in'
      },
      {
        id: 19,
        content: `TM and ©${new Date().getFullYear()} are owned by Burger King Company LLC. Used under the license. All rights reserved.`
      },
      {
        id: 20,
        content:
          'In case of any dispute, the courts in Mumbai will have exclusive jurisdiction.'
      }
    ];

    const vegTermsData = [
      {
        id: 1,
        content:
          'Tasty Meals starting at just Rs.99* is applicable only on purchase of Crispy Veg regular meal from Burger King restaurants.'
      },
      {
        id: 2,
        content:
          'Prices of other regular meals under the Tasty Meals offer section are as follows:',
        subItems: [
          'Veg Makhani Burst Regular Meal: Rs. 109*',
          'Crunchy Veg Taco Regular Meal: Rs. 119*',
          'Crispy Chicken Regular Meal: Rs.149*',
          'Chicken Makhani Burst Regular Meal: Rs. 159*',
          'Crunchy Chicken Taco Regular Meal: Rs. 169*'
        ]
      },
      {
        id: 3,
        content:
          'Tasty Meals offer is available in selected restaurants in select cities only.'
      },
      {
        id: 4,
        content:
          'Tasty Meals offer is not valid in Airport & Franchised Burger King restaurants.'
      },
      {
        id: 5,
        content:
          'Tasty Meals pricing is excluding any taxes, delivery charges, restaurant handling charges or any other charges/ expenses incurred by us (*).'
      },
      {
        id: 6,
        content:
          'Tasty Meals starting at just Rs.99* is applicable only on regular meals.'
      },
      {
        id: 7,
        content:
          'Regular Meal includes Regular Fries & Regular Pepsi Black only.'
      },
      {
        id: 8,
        content:
          'Regular Meals cannot be upgraded to Medium and/or King (Large) Meals.'
      },
      {
        id: 9,
        content: 'Tasty Meals offer does not apply to other combos.'
      },
      {
        id: 10,
        content:
          'Tasty Meals offer is applicable only in Burger King Dine-in/ Takeaway.'
      },
      {
        id: 11,
        content:
          'Tasty Meals offer cannot be combined with any other offer/coupons.'
      },
      {
        id: 12,
        content: 'Burger/Meal Customisation will be charged extra.'
      }
    ];

    const freeCrispyVeg = [
      {
        id: 1,
        content:
          'Free Crispy Veg offer will be applicable only on BK App (dine-in, delivery & express)'
      },
      {
        id: 2,
        content:
          'The aforesaid offer can only be availed on purchase of a minimum order value (MoV) of Rs. 99/- for the Burger King products.'
      },
      {
        id: 3,
        content:
          'The offer can be availed only on your1 st order done through the BK App. Any new member (new app download & registered, or existing member but who have not made any transaction on BK App) can avail of this offer.'
      },
      {
        id: 4,
        content:
          'The offer is available only in select cities and restaurant. Selection of cities and restaurants are at sole discretion of Burger King India.'
      },
      {
        id: 5,
        content:
          'The offer can be applied on the total bill of Rs. 99/- which can include both discounted or non-discounted Burger King products.'
      },
      {
        id: 6,
        content:
          'The coupon to avail Free Crispy Veg will be visible in the ‘Offers’ section in the checkout page of the BK App.'
      },
      {
        id: 7,
        content: 'Two coupons cannot be applied on the same invoice.'
      },
      {
        id: 8,
        content:
          'Burger King’s maximum liability is not more than the amount of the order placed by the customer.'
      },
      {
        id: 9,
        content:
          'For any further information, you can contact by writing to us at customercare@burgerking.in'
      },
      {
        id: 10,
        content:
          'TM & © 2025 BURGER KING COMPANY LLC. Used under the license. All rights reserved.'
      },
      {
        id: 11,
        content:
          'The offer is not valid in Airport & Franchised Burger King restaurants.'
      },
      {
        id: 12,
        content:
          'Burger King India reserves the right to cancel, reduce, amend, extend, modify, or withdraw the offer at its sole discretion at any time without prior notice. No claims or questions will be entertained in this regard.'
      },
      {
        id: 13,
        content:
          'Restaurant timings may vary by location. Restaurant operations are subject to state and local government guidelines, including permitted services and timings in different zones.'
      },
      {
        id: 14,
        content:
          'In case of any disputes, the courts in Mumbai shall have exclusive jurisdiction.'
      }
    ];

    const ccTerms = [
      {
        id: 1,
        content:
          '2 Crispy Veg for ₹79* and 2  Crispy Chicken for ₹99* (this “Offer”) is applicable only on purchase of Crispy Veg and Crispy Chicken from Burger King restaurants.'
      },
      {
        id: 2,
        content:
          'This Offer is available in selected restaurants in select cities only.'
      },
      {
        id: 3,
        content:
          'This Offer is not valid in Airport & Franchised Burger King restaurants.'
      },
      {
        id: 4,
        content:
          'Offer pricings are excluding any taxes, delivery charges, restaurant handling charges or any other charges/ expenses incurred by us (*).'
      },
      {
        id: 5,
        content: 'This Offer does not apply to other combos.'
      },
      {
        id: 6,
        content:
          'This Offer is applicable only in Burger King Dine-in/ Takeaway.'
      },
      {
        id: 7,
        content: 'This Offer cannot be combined with any other offer/coupons.'
      },
      {
        id: 8,
        content: 'Burger/Meal Customization will be charged extra.'
      },
      {
        id: 9,
        content:
          '“Just Add Coke” isn’t included in this Offer. Adding Coke will be charged extra. Coca-Cola, Thumbs up, Coffee products contain caffeine. Coke Zero contains caffeine & non-caloric sweetener. This carbonated water contains an admixture of sucralose & acesulfame potassium. Not recommended for children; pregnant & lactating mothers.'
      },
      {
        id: 10,
        content:
          'This Offer is applicable only in Burger King Dine-in/ Takeaway.'
      }
    ];

    const fathersDayTermsAndConditions = [
      {
        heading: 'How to participate in the #BKDadTax',
        points: [
          'Follow our official Instagram handle i.e. @BurgerKingIndia.',
          'Capture and post a picture of your father claiming his Dad Tax whether it"s a fry, burger bite or any share of your meal on your story.',
          'Tag @BurgerKingIndia and use the hashtag #BKDadTax.',
          'Participants must have their own valid/genuine public Instagram account for us to track their entry.',
          'Burger King will DM a free coupon code to eligible winners which can be redeemed only at Burger King restaurants through the BK App Dine-in section, subject to the below T&C.'
        ]
      },
      {
        heading: 'Terms and Conditions (T&C)',
        points: [
          'For the purpose of these Terms and Conditions, "Burger King India" means Restaurant Brands Asia Limited (formerly known as Burger King India Limited), which operates Burger King® restaurants in India.',
          'Entries will only be considered valid if the participants follow all the steps mentioned above accurately.',
          'Participants must have their own public Instagram account for us to be able to track valid entries.',
          'The contest entries will commence from 20th June 2026 and end on 21st June 2026 at 11:59 PM IST. Any entries received after this period shall not be eligible for the #BKDadTax.',
          'The offer is valid only for the first 1000 valid participants, subject to successful completion of the contest requirements and voucher availability.',
          'Participation in the contest does not guarantee receipt of a voucher, which shall be subject to eligibility verification and availability.',
          'Each valid entry/participation will win one (1) Fries (M) voucher only.',
          'Only one (1) participation shall be accepted from one (1) Instagram handle.',
          'Voucher codes shall be redeemable only through the Dine-in section on the Burger King App.',
          'The voucher entitles the customer to one (1) Fries (M) upon purchase of at least one (1) menu item through the Burger King App. The voucher cannot be redeemed as a standalone order.',
          'Voucher codes shall not be valid at Airport and Franchisee Burger King restaurants.',
          'Voucher codes are valid for a limited period only, i.e. from 22nd June 2026 to 22nd September 2026.',
          'Voucher codes are personal to the recipient, non-transferable, non-exchangeable and cannot be redeemed for cash or any other benefit.',
          'Burger King India reserves the right to discontinue issuance of vouchers once the limit of 1000 valid winners is reached.',
          'Burger King India reserves the right to cancel, reduce, amend, extend, modify or withdraw the offer and/or contest at its sole discretion at any time without prior notice to the participants. No claims/questions shall be entertained in this regard.',
          'Impersonated Instagram handles and/or fake accounts (if identified or reported) shall be disqualified.',
          'Burger King India reserves the right to disqualify any participant found to be engaging in fraudulent, abusive, manipulative or unfair practices, including creation of multiple accounts, automated participation or any conduct intended to circumvent the contest rules.',
          'Restaurant timings may vary across locations. Restaurant operations shall remain subject to applicable State and Local Government guidelines and permitted operating hours/services.',
          'The voucher shall be sent to the winners via Instagram DM. Burger King India team shall contact the winners and share the voucher code through Instagram Direct Message only.',
          'Burger King India shall not be responsible for any technical failures, network issues, platform disruptions, system errors or any other circumstances beyond its reasonable control that may affect in the redemption of vouchers.',
          'By entering this contest pursuant to these T&C, each participant agrees to be bound by these T&C and by the sole decision(s) of Burger King India, whose decision shall be final and binding in relation to all matters connected with the contest. Burger King India shall not entertain any further correspondence in this regard.',
          'In case of any dispute, courts at Mumbai shall have exclusive jurisdiction.'
        ]
      },
      {
        heading: 'Steps to Redeem',
        points: [
          'Download the Burger King App and login using your registered mobile number.',
          'Add at least one (1) product to the cart.',
          'Before payment, select "View Offers" under the Offers tab.',
          'Enter the coupon code shared via Instagram DM and click "Apply".',
          'Upon successful application of the voucher code, one (1) Fries (M) shall automatically be added to the cart free of cost.'
        ]
      }
    ];

    const spriteSpicyChallengeTermsAndConditions = [
      {
        id: '1',
        content:
          'To redeem BK Voucher, customer has must successfully register and maintain an active account on the BK App.'
      },
      {
        id: '2',
        content:
          'Voucher may be redeemed only through the Burger King App for Dine-in transactions at participating Burger King restaurants and shall not be valid at airport stores, franchisee-operated stores (where applicable) or any excluded locations notified by Burger King.'
      },
      {
        id: '3',
        content:
          'Voucher may be redeemed only against an eligible Peri Peri + Sprite Combo after at least one qualifying item has been added to the cart.'
      },
      {
        id: '4',
        content:
          'The Promotion shall not be open to residents of, or purchases made within, the State of Tamil Nadu, or any other jurisdiction where participation in such promotional schemes is prohibited under applicable law.'
      },
      {
        id: '5',
        content:
          'Each registered mobile number and corresponding BK App account shall be entitled to redeem only one (1) coupon code during the Promotion Period.'
      },
      {
        id: '6',
        content:
          'Coupon code name will be agnostic of code being typed in caps/no caps by the user.'
      },
      {
        id: '7',
        content:
          'Coupon code shall be valid only for the eligible Burger King products specifically identified under this promotion, subject to availability.'
      },
      {
        id: '8',
        content:
          'Coupon code shall provide a discount of 40% on the applicable Peri Peri Veg Whopper + Regular Sprite Combo (or such other eligible combinations as communicated by Burger King during the Promotion Period).'
      },
      {
        id: '9',
        content:
          'Offer valid from 15thAugust 2026 to 13th November 2026 (both dates inclusive), unless extended or withdrawn by Burger King in accordance with these Terms.'
      },
      {
        id: '10',
        content:
          'Offer cannot be combined with any other coupon, promotional offer, employee discount or loyalty benefit, unless expressly stated otherwise.'
      },
      {
        id: '11',
        content:
          'Burger King India reserves the right to modify, suspend or withdraw the offer in the event of fraud, technical failure, regulatory requirements or circumstances beyond its reasonable control.'
      }
    ];

    return (
      <>
        <div
          className={`privacy-pg_wrapper ${
            pathname === '/promotional-terms' ? 'privacy-pg_full' : ''
          }`}
        >
          {pathname === '/promotional-terms' ? (
            ''
          ) : (
            <AccountSubSecTitle
              title="Promotional Terms and Conditions"
              goBackOnClick={goBackOnClick}
              hideBackArrow={pathname === '/promotional-terms' || false}
              theme={theme}
            />
          )}
          <div className="privacy-pg">
            {pathname === '/promotional-terms' ? (
              <AccountSubSecTitle
                title="Promotional Terms and Conditions"
                goBackOnClick={goBackOnClick}
                // hideBackArrow={pathname === '/promotional-terms' || false}
                theme={theme}
              />
            ) : (
              ''
            )}
            <div className="privacy-pg__content">
              <p className="privacy-pg__title">Terms and Conditions (T&C)</p>
              <p className="privacy-pg__title  u_text_transform_uppercase">
                IMPORTANT : PLEASE CAREFULLY READ AND UNDERSTAND THESE
                PROMOTIONAL TERMS AND CONDITIONS. THEY CONTAIN LIMITATIONS ON
                RESTAURANT BRANDS ASIA LIMITED’S LIABILITY AND OTHER PROVISIONS
                THAT AFFECT YOUR LEGAL RIGHTS.
              </p>
              <ol className="privacy-pg__list">
                {terms_conditions.map((term, index) => (
                  <li
                    className={`privacy-pg__info ${
                      index === 3 ? 'bold-text' : ''
                    }`}
                    key={term.id}
                  >
                    {term.content}
                    {term.subItems && (
                      <ul
                        style={{
                          listStyleType: 'disc'
                        }}
                      >
                        {term.subItems.map((subItem, subIndex) => (
                          <>
                            <li
                              key={subIndex.toString() + subItem}
                              className="ml-2 bold-text"
                            >
                              {subItem}
                            </li>
                          </>
                        ))}
                      </ul>
                    )}
                  </li>
                ))}
              </ol>
              {/* </div> */}

              <br />
              <p className="privacy-pg__title  u_text_transform_uppercase">
                Terms and Conditions for Free Crispy Veg Offer (T&amp;C):
              </p>
              <br />
              <ol className="privacy-pg__list">
                {freeCrispyVeg.map(term => (
                  <li className="privacy-pg__info" key={term.id}>
                    {term.content}
                    {term.subItems && (
                      <ul
                        style={{
                          listStyleType: 'disc'
                        }}
                      >
                        {term.subItems.map((subItem, index) => (
                          <>
                            <br />
                            <li key={index.toString()} className="ml-2">
                              {subItem}
                            </li>
                          </>
                        ))}
                      </ul>
                    )}
                  </li>
                ))}
              </ol>

              <br />
              <p className="privacy-pg__title  u_text_transform_uppercase">
                Terms & Condition of offer 2 Crispy Veg for ₹79* and 2 Crispy
                Chicken for ₹99*
              </p>
              <br />
              <ol className="privacy-pg__list">
                {ccTerms.map(term => (
                  <li className="privacy-pg__info" key={term.id}>
                    {term.content}
                    {term.subItems && (
                      <ul
                        style={{
                          listStyleType: 'disc'
                        }}
                      >
                        {term.subItems.map((subItem, index) => (
                          <>
                            {/* <br /> */}
                            <li key={index.toStrin()} className="ml-2">
                              {subItem}
                            </li>
                          </>
                        ))}
                      </ul>
                    )}
                  </li>
                ))}
              </ol>

              <br />
              <p className="privacy-pg__title  u_text_transform_uppercase">
                Terms & Condition of offer Tasty Meals starting @Rs. 99*
              </p>
              <br />
              <ol className="privacy-pg__list">
                {vegTermsData.map(term => (
                  <li className="privacy-pg__info" key={term.id}>
                    {term.content}
                    {term.subItems && (
                      <ul
                        style={{
                          listStyleType: 'disc'
                        }}
                      >
                        {term.subItems.map((subItem, index) => (
                          <>
                            <br />
                            <li key={index.toString()} className="ml-2">
                              {subItem}
                            </li>
                          </>
                        ))}
                      </ul>
                    )}
                  </li>
                ))}
              </ol>
              <br />

              <div style={{ paddingLeft: '1.6rem' }}>
                <h6 className="terms-pg__title u_text_transform_uppercase">
                  Father&apos;s Day – Terms & Conditions
                </h6>
                <div>
                  {fathersDayTermsAndConditions.map(
                    this.renderFathersDayHeadingAndText
                  )}
                </div>
                {spriteSpicyChallengeTermsAndConditions.length > 0 && (
                  <>
                    <h6 className="terms-pg__title u_text_transform_uppercase">
                      Terms & Conditions for Sprite Spicy Challenge
                    </h6>
                    <ol className="privacy-pg__list">
                      {spriteSpicyChallengeTermsAndConditions.map(item => (
                        <li className="privacy-pg__info" key={item.id}>
                          {item.content}
                        </li>
                      ))}
                    </ol>
                  </>
                )}
              </div>
            </div>
          </div>
          {pathname === '/promotional-terms' ? <Footer /> : ''}
        </div>
        <div className="u_mobile-footer">
          {isMobileScreen && !isAccountScreen && (
            <MobileFooter
              activeKey={activeKey}
              mobileFooterClick={mobileFooterClickHandler}
              theme={theme}
            />
          )}
        </div>
      </>
    );
  }
}

export default withMobileHeaderFooterAdding(
  withRouter(PromotionalPrivacyPolicy)
);
